import {Alert, Snackbar, styled} from '@mui/material'
import {useUseCases} from '../../store/hooks/useCase'

export const StyledAlert = styled(Alert)(({theme}) => ({
  fontSize: theme.typography.body1.fontSize,
  marginTop: '17px'
}))
const UseCaseFilterAlert = () => {
  const {isSnackBarOpen, setIsSnackBarOpen, snackbarMessage} = useUseCases()
  const handleSnackbarClose = (event, reason) => {
    if (reason === 'clickaway') return
    setIsSnackBarOpen(false)
  }
  return (
    <Snackbar
      open={isSnackBarOpen}
      autoHideDuration={5000}
      sx={{minWidth: '60%', maxWidth: '70%'}}
      onClose={handleSnackbarClose}
      anchorOrigin={{vertical: 'top', horizontal: 'center'}}
    >
      <StyledAlert variant='alert' onClose={handleSnackbarClose} severity='warning' sx={{width: '100%'}}>
        {snackbarMessage}
      </StyledAlert>
    </Snackbar>
  )
}

export default UseCaseFilterAlert
